<template>
  <div class="chat">
    <!-- 顶部 -->
    <div class="header">
      {{ $t("AiChat.title") }}
      <el-icon @click="methods.close" class="SemiSelect">
        <Close />
      </el-icon>
      <el-icon class="FullScreen" @click="methods.FullScreenBtn">
        <FullScreen />
      </el-icon>
    </div>
    <div class="content">
      <!-- 中间显示内容部分 -->
      <div class="v-chat-record">
        <div
          :key="idx"
          v-for="(item, idx) in state.rightList"
          :class="[
            'v-chat-record-item',
            item.type == 1 || item.type == 3
              ? 'v-chat-record-left-item'
              : 'v-chat-record-right-item',
          ]"
        >
          <div
            class="v-chat-record-item-box"
            v-if="item.type == 1 || item.type == 3"
          >
            <img :src="item.img" />
            <div class="v-chat-record-item-child">
              <span
                v-if="
                  item.content.includes('```') &&
                  !methods.isMarkdown(item.content)
                "
              >
                <highlightjs autodetect :code="item.content" />
              </span>
              <div v-else v-html="methods.renderMarkdown(item.content)"></div>
              <!-- <span v-else style="white-space: pre-wrap">
                {{ item.content }}
              </span> -->
              <el-table
                :data="item.data"
                style="width: 100%"
                v-if="item.data != undefined"
              >
                <el-table-column
                  v-for="row in item.config"
                  :prop="row.column_name"
                  :key="row.sort_num"
                  :label="row.column_name"
                  :width="row.width"
                />
              </el-table>
              <!-- <el-form
                label-width="30%"
                :rules="formRules"
                style="margin: 10Px 0 10Px; text-align: center"
                :model="item.input"
                v-if="item.resFormat == 'input'"
              >
                <el-form-item
                  :label="t('AiChat.customerForm.productLabel')"
                  prop="product_line_id"
                >
                  <el-select
                    v-model="item.input.product_line_id"
                    :placeholder="t('AiChat.customerForm.productPlaceholder')"
                    style="width: 100%"
                    filterable
                    clearable
                    :disabled="item.input.is_submit"
                  >
                    <el-option
                      v-for="productLineData in state.productLineList"
                      :key="productLineData.id"
                      :label="productLineData.product_line_name"
                      :value="productLineData.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="t('AiChat.customerForm.phoneLabel')"
                  prop="customer_phone"
                >
                  <el-input
                    :placeholder="t('AiChat.customerForm.phonePlaceholder')"
                    :disabled="item.input.is_submit"
                    v-model="item.input.customer_phone"
                  />
                </el-form-item>
                <el-form-item
                  :label="t('AiChat.customerForm.nameLabel')"
                  prop="customer_name"
                >
                  <el-input
                    :placeholder="t('AiChat.customerForm.namePlaceholder')"
                    :disabled="item.input.is_submit"
                    v-model="item.input.customer_name"
                  />
                </el-form-item>
                <el-button
                  style="width: 80%"
                  v-if="!item.input.is_submit"
                  type="primary"
                  @click="methods.saveCustomer(item)"
                  >提交</el-button
                >
              </el-form> -->
            </div>
          </div>
          <div class="v-chat-record-item-box v-chat-record-item-box_2" v-else>
            <div class="v-chat-record-item-child">{{ item.content }}</div>
            <!-- <div class="empName">{{ state.empName }}</div> -->
          </div>
        </div>

        <div class="show_box" v-if="state.isWaitShow">
          <img src="@/assets/ai/bot_chat.png" />
          <div class="show">{{ $t("AiChat.loading") }}</div>
        </div>
      </div>

      <!-- 底部输入内容部分 -->
      <div class="v-chat-input">
        <div class="v-chat-content">
          <!-- <VEmojiPicker  @select="selectEmoji" /> -->
          <el-input
            ref="inputField"
            type="textarea"
            :disabled="state.isShow"
            :placeholder="$t('AiChat.placeholder')"
            @keyup.enter="methods.submit"
            v-model="state.text"
          >
          </el-input>
        </div>
        <div class="v-btn-submit">
          <!-- <el-tooltip v-model="state.tooltipv" content="点击发送" placement="top" effect="light"> -->
          <el-button
            :disabled="state.isShow"
            @click="methods.submit"
            style="margin-bottom: 14Px"
            >{{ $t("AiChat.send") }}</el-button
          >
          <!-- </el-tooltip> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineEmits,
  defineProps,
  reactive,
  ref,
  onMounted,
  nextTick,
  computed,
  watch,
} from "vue";
import store from "@/store";
import {
  GetSessionRecord,
  UpdateChat,
  SaveCustomer,
  GetProductLineList,
} from "@/api/ai";
import { ElMessage, ElMessageBox } from "element-plus";
import "highlight.js/styles/atom-one-dark.css";
import MarkdownIt from "markdown-it";
import { useI18n } from "vue-i18n";
import "highlight.js/lib/common";
import hljs from "highlight.js";
const emit = defineEmits(["childClick"]);
const props = defineProps({
  chatGptShow: Boolean,
});
watch(
  () => props.chatGptShow,
  (newValue, oldValue) => {
    //console.log(props.chatGptShow);
    to_footer();
    if (!props.chatGptShow) visible.value = false;
  }
);
const md = new MarkdownIt().set({
  html: true,
  breaks: true,
  typographer: true,
  linkify: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs" style="overflow-y: auto"><code>' +
          hljs.highlight(lang, str, true).value +
          "</code></pre>"
        );
      } catch (__) {}
    }
    return (
      '<pre class="hljs" style="overflow-y: auto"><code>' +
      md.utils.escapeHtml(str) +
      "</code></pre>"
    );
  },
});
// 一次性注册需要的渲染规则
(() => {
  // 为链接添加 target="_blank"，并确保不产生递归
  const originalLinkOpen = md.renderer.rules.link_open;
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    let aIndex = tokens[idx].attrIndex("target");
    if (aIndex < 0) {
      tokens[idx].attrPush(["target", "_blank"]);
    } else {
      tokens[idx].attrs[aIndex][1] = "_blank";
    }
    if (typeof originalLinkOpen === "function") {
      return originalLinkOpen(tokens, idx, options, env, self);
    }
    return self.renderToken(tokens, idx, options);
  };

  // 统一处理图片渲染样式
  md.renderer.rules.image = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    const srcIndex = token.attrIndex("src");
    const src = token.attrs[srcIndex][1];
    const alt = token.content;
    const width = "90%";
    return `
            <img 
              src="${src}" 
              alt="${alt}" 
              style="max-width: ${width};"
              class="markdown-image"
            />
        `;
  };
})();
const { t } = useI18n();
const is_FullScreen = ref(false);
const visible = ref(false);
const inputField = ref(null);
const pageDate = computed((date) => {
  return (date) => {
    let days = moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(
      moment(moment(date).format("YYYY-MM-DD HH:mm:ss")),
      "minutes"
    );
    console.log();
    if (days > 43200) return moment(date).format("YYYY-MM-DD");
    else if (days < 43200 && days >= 1440)
      return (days / 60 / 24).toFixed() + "天前";
    else if (days < 1440 && days >= 60)
      return moment(moment(date).format("YYYY-MM-DD HH:mm:ss"))
        .startOf("hours")
        .fromNow()
        .replace(" ", "");
    else if (days < 60 && days >= 1)
      return moment(moment(date).format("YYYY-MM-DD HH:mm:ss"))
        .startOf("minutes")
        .fromNow()
        .replace(" ", "");
    else if (days < 1) return "刚刚";
  };
});
const formRules = reactive({
  product_line_id: [
    {
      required: true,
      message: "请选择沟通意向",
      trigger: "change",
      maxlength: 100,
    },
  ],
  customer_phone: [
    {
      required: true,
      message: "请输入电话号码",
      trigger: "input",
      maxlength: 100,
    },
  ],
  customer_name: [
    {
      message: "最多50个字符",
      trigger: "input",
      maxlength: 50,
    },
  ],
});
const state = reactive({
  recordList: "", //历史记录存储数据
  isInterfaceCode: false, //控制是否发起请假请求
  interfaceCode: "",
  bodyList: null, //存储的请假数据
  token: "111", //token
  isShow: false,
  isWaitShow: false,
  empName: "客户",
  tooltipv: "",
  text: "", //輸入框的值
  rightList: [],
  session_id: localStorage.getItem("session_id"),

  productLineList: [], //产品线列表
  ip: null,
});
function to_footer() {
  nextTick(() => {
    // 检测是否在移动端环境中
    const isMobile = window.innerWidth <= 767;
    setTimeout(() => {
      let div;
      
      // 移动端优先选择van-popup内可见的v-chat-record容器
      if (isMobile) {
        // 查找所有v-chat-record容器
        const allChatRecords = document.getElementsByClassName("v-chat-record");
        
        for (let i = 0; i < allChatRecords.length; i++) {
          const record = allChatRecords[i];
          const popup = record.closest('.van-popup');
          
          // 检查是否在van-popup内且popup是可见的
          if (popup) {
            const popupStyle = window.getComputedStyle(popup);
            const popupDisplay = popupStyle.display;
            const popupVisibility = popupStyle.visibility;
            
            // 检查popup是否可见
            if (popupDisplay !== 'none' && popupVisibility !== 'hidden') {
              div = record;
              break;
            }
          }
        }
      } else {
        div = document.getElementsByClassName("v-chat-record")[0];
      }
      if (!div) {
        return;
      }
      div.scrollTop = div.scrollHeight;
    }, 200);
  });
}

let methods = {
  getToken() {
    return "111";
  },
  FullScreenBtn() {
    is_FullScreen.value = !is_FullScreen.value;
    nextTick(() => {
      let box = document.getElementsByClassName("chat")[0];
      let dix = document.getElementsByClassName("v-chat-input")[0];
      if (is_FullScreen.value) {
        box.style.width = "100%";
        box.style.height = "100%";
        box.style.right = 0;
      } else {
        box.style.width = 500 + "Px";
        box.style.height = 700 + "Px";
        box.style.right = 80 + "Px";
        dix.style.bottom = 0;
      }
    });
  },
  close() {
    visible.value = false;
    emit("childClick");
  },
  // 按下发送
  async submit() {
    state.token = methods.getToken();

    state.isShow = true;
    state.isWaitShow = true;

    if (
      !state.text ||
      state.text == "" ||
      state.text.replace(/[\r\n]/g, "") == ""
    ) {
      state.isWaitShow = false;
      return (state.isShow = false);
    }
    state.text = state.text.replace(/[\r\n]/g, "");

    state.rightList.push({
      type: 2,
      content: state.text,
      role: "user",
    });
    to_footer();

    if (state.text == "Y" && state.isInterfaceCode) {
      axios
        .post(
          "/oa_ows/oa/ows/chat/GetFunctions",
          { body: state.bodyList, interfaceCode: state.interfaceCode },
          {
            headers: {
              Authorization: state.token,
              tenant_id: localStorage.getItem("tenant_id"),
            },
          }
        )
        .then((rex) => {
          if (
            rex.data.code == 200 &&
            rex.data.msg == "table" &&
            rex.data.body != undefined &&
            rex.data.config != undefined
          ) {
            state.rightList.push({
              img: require("@/assets/ai/bot_chat.png"),
              type: 1,
              role: "assistant",
              content: "",
              data: rex.data.body,
              config: rex.data.config,
            });
            state.isInterfaceCode = false;
            state.bodyList = null;
            state.interfaceCode = "";
            state.text = "";
            to_footer();
            state.isShow = false;
            state.isWaitShow = false;
          } else {
            state.rightList.push({
              img: require("@/assets/ai/bot_chat.png"),
              type: 1,
              role: "assistant",
              content: rex.data.msg,
            });
            state.isInterfaceCode = false;
            state.bodyList = null;
            state.interfaceCode = "";
            state.text = "";
            to_footer();
            state.isShow = false;
            state.isWaitShow = false;
          }
        });
      return;
    } else {
      setTimeout(async () => {
        to_footer();
        state.controller = new AbortController();
        const url = `/oa_ows/oa/ows/chat/GetAssistantAnswer`;
        try {
          state.session_id =
            state.session_id == "" ||
            state.session_id == null ||
            state.session_id == undefined ||
            state.session_id == "null"
              ? ""
              : state.session_id;
          //await methods.fetchPublicIP();        
          const stream = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              tenant_id: 0,
              Accept: "application/json, text/plain, */*",
              Connection: "close",
            },

            body: JSON.stringify({
              chat_client: 4,
              session_id: state.session_id,
              question: state.text,
              //client_ip:state.ip,
            }),
            signal: state.controller.signal, // 绑定中断信号
          });
          const reader = stream.body.getReader();
          let textChunk = "";
          state.isWaitShow = false;
          state.rightList.push({
            img: require("@/assets/ai/bot_chat.png"),
            type: 1,
            role: "assistant",
            content: textChunk,
          });
          let isTable = false;
          let faillines = "";
          let resFormat = "";
          let assistantContent = "";
          var textdecoder = new TextDecoder("utf-8");
          while (true) {
            if (state.controller.signal.aborted) {
              console.log("请求已被中止");
              await reader.cancel();
              break;
            }
            const { done, value } = await reader.read();
            // console.log(done);
            if (done) {
              console.log("流已完成");

              // 流已完成
              if (isTable && resFormat != "") {
                resFormat = methods.isJSON(resFormat)
                  ? JSON.parse(resFormat)
                  : resFormat;
                //console.log(resFormat);
                state.rightList[state.rightList.length - 1].currentPage = 1;
                state.rightList[state.rightList.length - 1].pageSize = 10;
                state.rightList[state.rightList.length - 1].total =
                  resFormat.body.length;
                const chunks = [];
                const len = resFormat.body.length;
                let start = 0;

                while (start < len) {
                  // 循环将数组分割成10个元素的子数组
                  chunks.push(resFormat.body.slice(start, start + 10));
                  start += 10;
                }
                state.rightList[state.rightList.length - 1].data = chunks;
                state.rightList[state.rightList.length - 1].rawdata =
                  resFormat.body;
                state.rightList[state.rightList.length - 1].config =
                  resFormat.config;
              }
              // methods.checkAndOpenLink(state.rightList[state.rightList.length - 1].content);
              (state.rightList[state.rightList.length - 1].feedback = null),
                (state.rightList[state.rightList.length - 1].createTime =
                  methods.getDate());
              state.isWaitShow = false;
              state.isShow = false;
              state.text = "";
              // 聚焦
              inputField.value.focus();
              to_footer();
              break;
            }
            // 处理接收到的chunk
            var decoder = textdecoder.decode(value, { stream: !done });
            // 可能获取到多个JSON对象,拆分为行
            const lines = decoder
              .split("\n\n")
              .filter((line) => line.trim() !== "");
            //console.log(lines);
            for (const line of lines) {
              // 转换为json字符串
              const jsonStr = line.startsWith("data: ") ? line.slice(6) : line;
              // 检查是否结束
              if (jsonStr === "[DONE]") {
                //console.log("流式响应完成，读取完毕");
                continue;
              }
              //转换为js对象
              try {
                if (faillines != "") {
                  //console.log("拼接", faillines);
                  faillines += jsonStr;
                  jsonStr = faillines.startsWith("data: ")
                    ? faillines.slice(6)
                    : faillines;
                }
                if (methods.isJSON(jsonStr)) {
                  if (faillines != "") {
                    //console.log("结束：", faillines);
                    faillines = "";
                  }
                  const jsData = JSON.parse(jsonStr);
                  if (jsData.choices[0].delta.content) {
                    if (
                      state.session_id == "" ||
                      state.session_id == null ||
                      state.session_id == undefined
                    ) {
                      state.session_id = jsData.choices[0].session_id;
                      localStorage.setItem(
                        "session_id",
                        jsData.choices[0].session_id
                      );
                    }
                    var content = jsData.choices[0].delta.content;
                    assistantContent += content;
                    state.rightList[state.rightList.length - 1].id =
                      jsData.choices[0].chat_id;
                    const format = jsData.choices[0].format;
                    //判断是否是表格

                    if (
                      format === "table" ||
                      assistantContent.startsWith('{"resFormat": "table"')
                    ) {
                      isTable = true;
                    }
                    if (methods.isJSON(content)) {
                      content = JSON.parse(content);
                    }
                    //console.log(format);
                    if (content.resFormat != undefined) {
                      if (content.body == null) {
                        state.rightList[state.rightList.length - 1].data =
                          undefined;
                        state.rightList[state.rightList.length - 1].content =
                          "暂无数据";
                      } else {
                        resFormat = content;
                        state.rightList[state.rightList.length - 1].data =
                          content.body;
                        state.rightList[state.rightList.length - 1].config =
                          content.config;
                      }
                    } else if (isTable) {
                      resFormat += content;
                    } else if (content.interfaceCode != undefined) {
                      let dataList = "";
                      for (const key in content.display[0]) {
                        dataList +=
                          key + "：" + content.display[0][key] + "" + "\n";
                      }
                      dataList =
                        dataList + "输入Y继续发起请求，输入N取消该次请求。";
                      state.rightList[state.rightList.length - 1].content =
                        dataList;
                      state.isInterfaceCode = true;
                      state.bodyList = content.body[0];
                      state.interfaceCode = content.interfaceCode;
                      state.isShow = false;
                      state.isWaitShow = false;
                      // } else if (format === "input") {
                      //   //console.log(state.rightList[state.rightList.length - 1]);
                      //   let id = state.rightList[state.rightList.length - 1].id;
                      //   let content =
                      //     state.rightList[state.rightList.length - 1].content;
                      //   let answer = {
                      //     content: content,
                      //     body: {
                      //       product_line_id: "",
                      //       customer_name: "",
                      //       customer_phone: "",
                      //       session_id: state.session_id,
                      //       contact_status: "",
                      //       is_submit: false,
                      //     },
                      //   };
                      //   UpdateChat({
                      //     id: id,
                      //     answer: JSON.stringify(answer),
                      //     res_format: "input",
                      //   }).then((res) => {
                      //     //console.log(res);
                      //   });
                      //   state.rightList.push({
                      //     img: require("@/assets/ai/bot_chat.png"),
                      //     type: 1,
                      //     role: "assistant",
                      //     content: "",
                      //     resFormat: "input",
                      //     input: {
                      //       product_line_id: "",
                      //       customer_name: "",
                      //       customer_phone: "",
                      //       session_id: state.session_id,
                      //       contact_status: "",
                      //       is_submit: false,
                      //     },
                      //     id: id,
                      //     answer: content,
                      //   });
                    } else {
                      //更新message
                      var think = methods.isThink(assistantContent);
                      state.rightList[state.rightList.length - 1].think = think;
                      //await new Promise((resolve) => setTimeout(resolve, 10));
                      content = assistantContent
                        .replace(think, "")
                        .replace("<think>", "")
                        .replace("</think>", "");
                      if (content.startsWith("\n\n")) {
                        content = content.substring(2);
                      }
                      state.rightList[state.rightList.length - 1].content =
                        content;
                      state.isInterfaceCode = false;
                      to_footer();
                    }
                  }
                } else {
                  faillines += line;
                }
              } catch (e) {
                console.error(e, jsonStr);
              }
            }
          }
        } catch (error) {
          state.isWaitShow = false;
              state.isShow = false;
              state.text = "";
              // 聚焦
              inputField.value.focus();
          if (error.name === "AbortError") {
            console.log("用户主动取消请求");
          } else {
            console.error("请求失败:", error);
          }
        }
      });
    }
    to_footer();
  },
  getDate: () => {
    var date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  },
  isJSON(str) {
    if (typeof str == "string") {
      try {
        var obj = JSON.parse(str);
        if (typeof obj == "object" && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  },
  isThink: (data) => {
    let match;
    var result = "";
    data = data
      .replace(/＜think＞/g, "<think>")
      .replace(/＜\/think＞/g, "</think>");
    const thinkTagRegex = /<think>(.*?)<\/think>/gs;
    const thinkStartRegex = /<think>(.*)/s;
    //console.log(data,"<think>","＜think＞＜/think＞");
    // 检查是否同时存在 <think> 和 </think>
    if ((match = thinkTagRegex.exec(data)) !== null) {
      result = match[1]; // 获取 <think></think> 中间的内容
    } else if ((match = thinkStartRegex.exec(data)) !== null) {
      result = match[1]; // 获取 <think> 后面所有内容
    } else {
      result = null; // 没有匹配到任何内容
    }
    return result;
  },


  // 转换markdown格式
  renderMarkdown: (text) => {
    try {
      return md.render(text);
    } catch (error) {
      console.log("Markdown渲染错误：", error);
      return text; // 如果渲染失败，则返回原始文本
    }
  },
  // 判断是否是markdown格式
  isMarkdown: (text) => {
    const markdownFeatures = [
      /^#{1,6}\s+.*$/gm, // 标头
      /\*.*?\*/g, // 粗体
      /_.+?_/g, // 强调
      /^\s*[*+-]\s+/gm, // ul列表
      /^\s*\d+\.\s+/gm, // ol列表
      /^>.*$/gm, // 区块引用
      /~~~[\s\S]+?~~~/, // 有围栏的代码块
      /\[.*?\]\(.*?\)/, // 链接
      /^(http?:\/\/[^\s]+)/, // 网址
      /!\[.*?\]\(.*?\)/, // 图片
      /\|.*?\|/g, // 表格
    ];
    return markdownFeatures.some((regex) => regex.test(text));
  },
  init() {
    //获取意向
    // GetProductLineList().then((res) => {
    //   state.productLineList = res.data;
    //   console.log(state.productLineList);
    // });
    state.session_id = localStorage.getItem("session_id"); // 获取session_id
    if (
      state.session_id == "" ||
      state.session_id == null ||
      state.session_id == undefined
    ) {
      state.rightList = [
        {
          img: require("@/assets/ai/bot_chat.png"),
          type: 3,
          content: t("AiChat.content"),
          role: "assistant",
        },
      ];
      return;
    }
    // 获取历史记录
    GetSessionRecord({
      page: 1,
      pageSize: 10,
      session_id: state.session_id,
    }).then((res) => {
      if (res.code != 200) {
        return ElMessage.warning("获取用户chatGpt历史记录失败");
      } else {
        if (res.data.length == 0) {
          state.rightList = [
            {
              img: require("@/assets/ai/bot_chat.png"),
              type: 3,
              content: t("AiChat.content"),
              role: "assistant",
            },
          ];
          state.sendRequest = false;
        }
        state.recordList = res.data;
        state.recordList.reverse();
        state.recordList.map((item) => {
          if (
            item.res_format == "table" ||
            item.res_format == "from" ||
            item.res_format == "input" ||
            (methods.isJSON(item.answer) &&
              JSON.parse(item.answer).resFormat == "table")
          ) {
            let resFormat = JSON.parse(item.answer);
            if (resFormat.body == null) {
              state.rightList.unshift({
                img: require("@/assets/ai/bot_chat.png"),
                type: 3,
                content: "暂无数据",
                role: "",
                data: undefined,
                feedback: item.feedback,
                search_type: item.search_type,
                search_result: JSON.parse(item.search_result),
                id: item.id,
              });
            } else if (item.res_format == "input") {
              state.rightList.unshift({
                img: require("@/assets/ai/bot_chat.png"),
                type: 3,
                content: resFormat.content,
                role: "assistant",
                feedback: item.feedback,
                search_type: item.search_type,
                search_result: JSON.parse(item.search_result),
                id: item.id,
              });
            } else {
              if (resFormat.interfaceCode != undefined) {
                let dataList = "";
                for (const key in resFormat.display[0]) {
                  dataList +=
                    key + "：" + resFormat.display[0][key] + "" + "\n";
                }
                state.rightList.unshift({
                  img: require("@/assets/ai/bot_chat.png"),
                  type: 3,
                  content: dataList,
                  role: "",
                  data: undefined,
                  feedback: item.feedback,
                  id: item.id,
                  search_type: item.search_type,
                  search_result: JSON.parse(item.search_result),
                });
                state.bodyList = resFormat.body[0];
                state.interfaceCode = resFormat.interfaceCode;
              } else {
                const chunks = [];
                const len = resFormat.body.length;
                let start = 0;
                while (start < len) {
                  // 循环将数组分割成若干个元素的子数组
                  chunks.push(resFormat.body.slice(start, start + 10));
                  start += 10;
                }
                state.rightList.unshift({
                  img: require("@/assets/ai/bot_chat.png"),
                  type: 3,
                  role: "",
                  content: "",
                  currentPage: 1,
                  pageSize: 10,
                  total: resFormat.body.length,
                  data: chunks,
                  rawdata: resFormat.body,
                  config: resFormat.config,
                  feedback: item.feedback,
                  id: item.id,
                  search_type: item.search_type,
                  search_result: JSON.parse(item.search_result),
                });
              }
            }
            state.rightList.unshift({
              type: 2,
              role: "user",
              content: item.question,
              // methods.to_footer();
            });
          } else {
            var content = item.answer;
            var think = methods.isThink(item.answer);
            content = content
              .replace(think, "")
              .replace("<think>", "")
              .replace("</think>", "")
              .replace(/＜think＞(.*?)＜\/think＞/gs, "");
            if (content.startsWith("\n\n")) {
              content = content.substring(2);
            }
            state.rightList.unshift({
              img: require("@/assets/ai/bot_chat.png"),
              type: 1,
              role: "assistant",
              content: content,
              think: think,
              feedback: item.feedback,
              id: item.id,
              search_type: item.search_type,
              search_result: JSON.parse(item.search_result),
            });
            state.rightList.unshift({
              type: 2,
              role: "user",
              content: item.question,
            });
          }
        });
        to_footer();
      }
    });
  },

  saveCustomer(data) {
    if (
      data.input.product_line_id == "" ||
      data.input.product_line_id == null ||
      data.input.product_line_id == undefined
    ) {
      ElMessage.warning("请选择产品线");
      return;
    }
    if (
      data.input.customer_phone == "" ||
      data.input.customer_phone == null ||
      data.input.customer_phone == undefined
    ) {
      ElMessage.warning("请输入手机号");
      return;
    }
    if (
      /^((0\d{2,3}-?\d{7,8})|(1[3-9]\d{9}))$/.exec(data.input.customer_phone) ==
      null
    ) {
      ElMessage.warning("手机号格式不正确");
      return;
    }
    let param = {
      product_line_id: data.input.product_line_id,
      customer_name: data.input.customer_name,
      customer_phone: data.input.customer_phone,
      contact_status: 0,
      session_id: data.input.session_id,
    };
    SaveCustomer(param).then((res) => {
      if (res.code == 200) {
        ElMessage.success("保存成功");
        data.input.is_submit = true;
        let id = data.id;
        let answer = { content: data.answer, body: data.input };
        UpdateChat({
          id: id,
          answer: JSON.stringify(answer),
          res_format: "input",
        }).then((res) => {
          console.log(res);
        });
      }
    });
  },

  async fetchPublicIP (){
  try {
    // 多个备用服务
    const services = [
      // 'https://api.ipify.org?format=json',
      'https://api64.ipify.org?format=json',
      'https://ipapi.co/json/',
      // 'https://jsonip.com/'
    ];
    for (const service of services) {
      try {
        const response = await fetch(service, { 
          timeout: 5000 
        });
        const data = await response.json();
        
        // 不同服务的响应格式不同
        if (service.includes('ipify')) {
          state.ip = data.ip;
        } else if (service.includes('ipapi')) {
          state.ip = data.ip;
        } else if (service.includes('jsonip')) {
          state.ip = data.ip;
        }
        if (state.ip) break; // 如果成功获取到IP，则跳出循环
      } catch (error) {
        continue;
      }
    }

  } catch (error) {
  }
},
};
onMounted(() => {
  //加载图片不发送任何原始页面的信息
  const meta = document.createElement("meta");
  meta.setAttribute("name", "referrer");
  meta.setAttribute("content", "no-referrer");
  document.getElementsByTagName("head")[0].appendChild(meta);
  methods.init();
});
</script>

<style lang="less" scoped>
.chat {
  width: 500Px;
  height: 700Px;
  z-index: 999;
  background-color: rgb(245, 245, 246);
  overflow: hidden;

  .header {
    position: relative;
    width: 100%;
    height: 50Px;
    background-color: rgb(243, 242, 241);
    line-height: 50Px;
    text-align: center;
    user-select: none;

    .SemiSelect {
      color: rgb(161, 160, 160);
      position: absolute;
      right: 10Px;
      top: 13Px;
      font-size: 25Px;
      cursor: pointer;
    }

    .SemiSelect:hover,
    .FullScreen:hover {
      color: red;
    }

    .FullScreen {
      color: rgb(161, 160, 160);
      position: absolute;
      right: 40Px;
      top: 13Px;
      font-size: 25Px;
      cursor: pointer;
    }
  }
}

.statement {
  color: rgb(200, 200, 201);
  text-align: center;
  width: 100%;
}

.v-chat-input {
  margin-left: 52Px;
  width: calc(100% - 70Px);
  height: 100Px;
  overflow: auto;
  background-color: #ffffff;
  position: absolute;
  bottom: 0;

  .v-btn-submit {
    position: absolute;
    right: 20Px;
    bottom: 2Px;

    .el-button {
      border-radius: 2Px;
      font-size: 14Px !important;
    }

    .el-button:hover {
      background-color: #1ca3f1 !important;
      color: #ffffff;
    }
  }

  .v-chat-content {
    position: absolute;
    bottom: 2Px;
    width: calc(100% - 20Px);
    height: 85Px;
    padding: 10Px;

    .el-textarea {
      border: none !important;
      width: 100% !important;
      height: 100% !important;

      ::v-deep .el-textarea__inner {
        border: none !important;
        resize: none;
        font-size: 14Px !important;
        color: #000000 !important;
        width: 100% !important;
        height: 100% !important;
      }
    }
  }

  .el-textarea__inner::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4Px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 4Px;
  }

  .el-textarea__inner::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5Px;
    -webkit-box-shadow: inset 0 0 5Px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .el-textarea__inner::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5Px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}

.content {
  width: 100%;
  height: 90%;
  position: relative;
}

.v-chat-record::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4Px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4Px;
}

.v-chat-record::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5Px;
  -webkit-box-shadow: inset 0 0 5Px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.v-chat-record::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5Px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.popoverTitle {
  text-align: center;
  font-weight: 600;
  font-size: 16Px;
  margin-bottom: 10Px;
}

.box {
  width: 100%;
  height: 100%;
  padding: 10Px 0;
  background-color: #eee;
  border-radius: 10Px;
}

.recordBoxTop {
  display: flex;
  justify-content: space-around;
  background-color: #1890ff;
  color: #fff;
  font-weight: 600;
  padding-left: 10Px;
  height: 20Px;

  :nth-child(1) {
    width: 60Px;
    text-align: center;
  }
}

.recordBox {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  text-align: center;
  height: 25Px;
  line-height: 25Px;

  :nth-child(1) {
    flex: 1.1;
    text-align: center;
  }

  :nth-child(2) {
    flex: 1;
  }

  :nth-child(3) {
    flex: 1;
  }
}

.recordBox:hover {
  font-weight: 600;
  background-color: #fff;
}

.v-chat-record {
  position: relative;
  height: 83%;
  overflow: auto;
  bottom: 0;

  .historyRecord {
    position: fixed;
    height: 20Px;
    width: 20Px;
    right: 5Px;
    bottom: 90Px;
    border: 1Px solid red;
    text-align: center;
    cursor: pointer;
    z-index: 9;
    border-radius: 10Px;

    .el-icon {
      line-height: 22Px;
      font-size: 15Px;
      color: red;
    }
  }

  .historyRecord:hover {
    border: 1Px solid rgb(24, 125, 255);
  }

  .historyRecord:hover .el-icon {
    color: rgb(24, 125, 255);
  }

  img {
    height: 35Px;
    width: 35Px;
  }

  .v-chat-record-item {
    // width: 90%;
    // display: flex;
    // // margin: 0 auto;
    word-wrap: break-word;
    margin: 10Px;
    // height:40Px;
    line-height: 25Px;
    font-size: 14Px;
  }

  .v-chat-record-item-box {
    // width: 200Px;
    display: flex;
  }

  .v-chat-record-right-item {
    position: relative;
    min-height: 40Px;
    height: auto;
    margin-top: 0;

    .v-chat-record-item-box {
      // height: 100%;
      // position: absolute;
      // text-align: right;
      // right: 0Px;
      // top: 0Px;
      // line-height: 40Px;
      justify-content: flex-end;
    }

    .v-chat-record-item-child {
      position: relative;
      left: -10Px;
      padding: 0 10Px;
      line-height: 40Px;
      animation: infinite 1s linear alternate;
    }
  }

  .v-chat-record-item-child {
    background-color: #ffffff;
    border-radius: 2Px;
    max-width: 75%;
    position: relative;
    padding: 0 10Px;
    left: 10Px;
    text-align: left;
  }
}

.empName {
  width: 40Px;
  height: 40Px;
  // background-color: rgb(24, 125, 255);
  text-align: center;
  color: #ffffff;
  border-radius: 5Px;
  line-height: 40Px !important;
}

.show {
  max-width: 75%;
  height: 35Px;
  background-color: #ffffff;
  margin-left: 10Px;
  box-sizing: border-box;
  padding-left: 10Px;
  font-size: 14Px;
}

.show_box {
  display: flex;
  margin: 10Px;
  line-height: 34Px;
}
@media only screen and (min-width: 768Px) {
  .chat {
    box-sizing: border-box;
    position: fixed;
    box-shadow: 1Px 1Px 8Px #999999, -1Px -1Px 8Px #999999;
    right: 85Px;
    top: 50%;
    transform: translate(0%, -50%);
    border-radius: 10Px;
  }
}
@media only screen and (max-width: 767Px) {
.chat {
  width: 100%;
  height: 100%;

  .header {
    position: relative;
    width: 100%;
    height: 50Px;
    background-color: rgb(243, 242, 241);
    line-height: 50Px;
    text-align: center;
    user-select: none;

    .SemiSelect {
      color: rgb(161, 160, 160);
      position: absolute;
      right: 10Px;
      top: 0Px;
      font-size: 25Px;
      cursor: pointer;
    }

    .SemiSelect:hover,
    .FullScreen:hover {
      color: red;
    }

    .FullScreen {
      display: none;
    }
  }
}
.v-chat-input {
  margin-left: 52Px;
  width: calc(100% - 70Px);
  height: 100Px;
  overflow: auto;
  background-color: #ffffff;
  position: absolute;
  bottom: 0;

  .v-btn-submit {
    position: absolute;
    right: 20Px;
    bottom: 2Px;

    .el-button {
      height: 20Px;
      border-radius: 2Px;
      font-size: 14Px !important;
    }

    .el-button:hover {
      background-color: #1ca3f1 !important;
      color: #ffffff;
    }
  }
}
}
</style>